/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Browsepagetitle2Inputs */

const zh_learn_browsepagetitle2 = /** @type {(inputs: Learn_Browsepagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开学习资源 | StudyOS`)
};

const en_learn_browsepagetitle2 = /** @type {(inputs: Learn_Browsepagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public Learning Resources | StudyOS`)
};

const es_learn_browsepagetitle2 = /** @type {(inputs: Learn_Browsepagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recursos públicos de aprendizaje | StudyOS`)
};

/**
* | output |
* | --- |
* | "Public Learning Resources \| StudyOS" |
*
* @param {Learn_Browsepagetitle2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_browsepagetitle2 = /** @type {((inputs?: Learn_Browsepagetitle2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Browsepagetitle2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_browsepagetitle2(inputs)
	if (locale === "en") return en_learn_browsepagetitle2(inputs)
	return es_learn_browsepagetitle2(inputs)
});
export { learn_browsepagetitle2 as "learn_browsePageTitle" }